import { useRef, useEffect } from 'react';

export const useInterval = (callback: () => void, delay: number) => {
  const ref = useRef({ savedCallback: () => {} });

  useEffect(() => {
    if (callback) {
      ref.current.savedCallback = callback;
    }
  }, [callback]);

  useEffect(() => {
    const id = setInterval(() => {
      if (ref) {
        ref.current.savedCallback();
      }
    }, delay);

    return () => clearInterval(id);
  }, [delay]);
};
